// NOTE: taken from media-items.module.css
export const mediaItemsColumnWidth = 240;

// NOTE: taken from media-items.module.css
export const mediaItemsColumnGap = 28;
